<template>
  <div class="w-full h-full mt-10px">
    <categoryTitle title="报警基本信息" />
    <el-form :model="form" label-width="150px">
      <el-form-item label="区域名称：">{{ form.name }}</el-form-item>
      <el-form-item label="静态风险等级：">
        <div :style="{ color: riskColor(form.staticRiskLevel) }">
          {{ form.staticRiskLevel }}
        </div>
      </el-form-item>
      <el-form-item label="风险分级管控清单："
        >{{ form.sourceCount }}
        <span
          class="cursor-pointer text-[var(--cockpitTreeNodeLabelColor)] ml-30px"
          @click="openStatistics"
          >查看</span
        >
      </el-form-item>
      <el-form-item label="动态最高风险等级：">
        <div :style="{ color: riskColor(form.dynamicRiskLevel) }">
          {{ form.dynamicRiskLevel }}
        </div>
      </el-form-item>
      <!-- <el-form-item label="关联报警数量：">{{ form.alarmCount }}</el-form-item> -->
    </el-form>
    <categoryTitle title="当前风险作业信息" />
    <div class="flex-1 mt-5px h-[calc(33.33%-70px)]">
      <el-table :data="workList" height="100%" empty-text="暂无作业信息">
        <el-table-column prop="name" label="作业名称" show-overflow-tooltip>
          <template slot-scope="scope">
            <div :style="{ color: riskColor(scope.row.level) }" class="truncate">
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="location" label="作业地点" show-overflow-tooltip>
          <template slot-scope="scope">
            <div :style="{ color: riskColor(scope.row.level) }" class="truncate">
              {{ scope.row.location }}
            </div>
          </template>
        </el-table-column> -->
        <el-table-column prop="level" label="风险级别" show-overflow-tooltip width="80px">
          <template slot-scope="scope">
            <div :style="{ color: riskColor(scope.row.level) }">
              {{ riskLevelMap[scope.row.level] }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <categoryTitle title="当前隐患信息" />
    <div class="flex-1 mt-5px h-[calc(33.33%-70px)]">
      <el-table
        :data="hiddenTroubleList"
        height="100%"
        @row-click="hiddenTroubleListRowClick"
        empty-text="暂无隐患信息"
      >
        <el-table-column prop="hiddenDangerName" label="隐患名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="riskLevelName" label="风险级别" show-overflow-tooltip>
          <template slot-scope="scope">
            <div :style="{ color: riskColor(scope.row.riskLevelName) }">
              {{ scope.row.riskLevelName }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <categoryTitle title="报警信息" />
    <div class="flex-1 mt-5px h-[calc(33.33%-70px)]">
      <el-table
        :data="alarmList"
        height="100%"
        @row-click="alarmRowClick"
        empty-text="暂无报警信息"
      >
        <el-table-column prop="name" label="报警名称" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="alarmObject" label="报警对象" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="alarmTime" label="报警时间" show-overflow-tooltip> </el-table-column>
      </el-table>
    </div>
    <PersonAlarmList
      v-if="alarmListVisible"
      :alarmListVisible.sync="alarmListVisible"
    ></PersonAlarmList>
    <AIAlarmListDialog
      v-if="aiAlarmListVisible"
      :isShowDialog.sync="aiAlarmListVisible"
    ></AIAlarmListDialog>
  </div>
</template>

<script>
import categoryTitle from '@/components/cockpit/CategoryTitle'
import { WorkTicketsApi, RiskAreaEvaluationApi, DashboardApi } from '@wiz-api/huizhou2-business'
import { HiddenDangerRectificationChecklistApi } from '@wiz-api/double-prevention-management'
import { StandardAlarmRecordApi } from '@wiz-api/personnel-position'
import { SecurityAlarmRecordApi } from '@wiz-api/security-management'
import { isEmpty, map, filter } from 'lodash'
import dayjs from 'dayjs'

// 报警列表
const PersonAlarmList = () => {
  return import('../components/PersonAlarmList')
}
const AIAlarmListDialog = () => {
  return import('../SmartSecurity/AIAlarmListDialog')
}
const workTicketsApi = new WorkTicketsApi()
const hiddenDangerRectificationChecklistApi = new HiddenDangerRectificationChecklistApi()
const standardAlarmRecordApi = new StandardAlarmRecordApi()
const securityAlarmRecordApi = new SecurityAlarmRecordApi()
const riskAreaEvaluationApi = new RiskAreaEvaluationApi()
const dashboardApi = new DashboardApi()

export default {
  name: 'risk-area-detail',
  components: {
    categoryTitle,
    PersonAlarmList,
    AIAlarmListDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    riskColor() {
      return (val) => {
        let color = ''
        switch (val) {
          case '重大风险':
          case '高风险':
          case '高':
            color = '#ff3a30'
            break
          case '较大风险':
          case '中风险':
          case '中':
            color = '#ff9502'
            break
          case '一般风险':
            color = '#f8b200'
            break
          case '低风险':
          case '低':
            color = '#1892FF'
            break
          default:
            color = '#0082f7'
            break
        }
        return color
      }
    },
  },
  data() {
    return {
      form: {
        sourceCount: 0,
      },
      workList: [],
      riskLevelMap: {
        0: '低',
        1: '中',
        2: '高',
      },
      riskLevelEnum: {
        4: '重大风险',
        3: '较大风险',
        2: '一般风险',
        1: '低风险',
      },
      riskHiddenTroubleEnum: {
        0: '重大风险',
        1: '较大风险',
        2: '一般风险',
        3: '低风险',
      },
      hiddenTroubleList: [],
      alarmList: [],
      alarmListVisible: false,
      aiAlarmListVisible: false,
    }
  },
  watch: {
    transferProps: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal?.areaDetail?.id !== oldVal?.areaDetail?.id) {
          const areaDetail = newVal.areaDetail
          this.form = {
            name: areaDetail.name,
            alarmCount: areaDetail.alarmCount,
            staticRiskLevel: this.riskLevelEnum[areaDetail.staticRiskGrade],
            dynamicRiskLevel: this.riskLevelEnum[areaDetail.maxRiskGrade],
          }
          this.getRiskEvaluationCount()
          this.getHiddenTroubleList()
          if (!isEmpty(areaDetail.id)) {
            this.getWorkTicketList()
          }
          this.getAlarmList()
        }
      },
    },
  },
  methods: {
    async getRiskEvaluationCount() {
      const [err, res] = await riskAreaEvaluationApi.getCountByAreaManagementAreaId({
        areaManagementAreaId: this.transferProps.areaDetail.id,
      })
      if (!err) {
        this.form.sourceCount = res?.sourceCount || 0
      }
    },
    openStatistics() {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'RiskAreaEvalutionStatistics',
            origin: 'tag',
            name: '区域风险分级管控清单',
          },
          type: 'tags',
          props: {
            areaDetail: this.transferProps.areaDetail,
          },
        },
      })
      window.dispatchEvent(openEvent)
    },
    async getWorkTicketList() {
      const [err, res] = await dashboardApi.getRiskWorkItem({
        riskAreaId: this.transferProps.areaDetail.id,
      })
      if (!err) {
        this.workList = res
      }
    },
    async getHiddenTroubleList() {
      const [
        err,
        res,
      ] = await hiddenDangerRectificationChecklistApi.hiddenDangersRectificationPagedListQuery({
        skipCount: 0,
        maxResultCount: 999,
        areaId: this.transferProps.areaDetail.id,
      })
      if (!err) {
        const data = filter(res.items, (item) => {
          return item.hiddenDangerRectificationStatus !== 2
        })
        this.hiddenTroubleList = map(data, (item) => {
          return {
            ...item,
            riskLevelName: this.riskHiddenTroubleEnum[item.riskLevel],
          }
        })
      }
    },
    async getAlarmList() {
      this.alarmList = []
      const [err1, res1] = await standardAlarmRecordApi.getList({
        skipCount: 0,
        maxResultCount: 999,
        standardFenceId: this.transferProps.areaDetail.fenceId,
        alarmRemoveType: 0,
        dataSource: 2,
      })
      if (!err1) {
        res1.items.forEach((item) => {
          this.alarmList.push({
            type: '1',
            name: `${item.personNames}${item.alarmTypeName}${item.fenceName}`,
            alarmObject: item.personNames,
            alarmTime: dayjs(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss'),
          })
        })
      }
      if (!isEmpty(this.transferProps.areaDetail.cameraIds)) {
        const [err2, res2] = await securityAlarmRecordApi.getDevicePositionWithWarning({
          isAlarm: true,
          deviceTypeCode: 'Camera',
          deviceIds: this.transferProps.areaDetail.cameraIds.split(','),
        })
        if (!err2) {
          res2.forEach((item) => {
            this.alarmList.push({
              type: '2',
              name: item.alarmType,
              alarmObject: item.devicecName,
              alarmTime: dayjs(item.alarmTime).format('YYYY-MM-DD HH:mm:ss'),
            })
          })
        }
      }
    },
    workRowClick(row) {
      const openEvent = new CustomEvent('openComponent', {
        detail: {
          toCom: {
            code: 'ElectricalWorkVote',
            origin: 'tag',
            name: row.prTicketType,
            originTagName: 'RiskAssignment',
          },
          type: 'tags',
          props: {
            buildingId: row,
          },
        },
      })
      window.dispatchEvent(openEvent)
      // 定位
      this.cloudRender.Camera.moveCamera('Code', row.prDeviceCode)
    },
    hiddenTroubleListRowClick(row) {
      window.open(
        `/double-prevention-management-hz/rectification/hidden-Accept?id=${row.id}&mode=read`
      )
    },
    alarmRowClick(row) {
      if (row.type === '1') {
        this.alarmListVisible = true
      } else {
        this.aiAlarmListVisible = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form {
  .el-form-item {
    margin-bottom: 0px;
    .el-form-item__label,
    .el-form-item__content {
      line-height: 28px;
      color: #fff;
    }
  }
}

::v-deep .el-table {
  .el-table__empty-block {
    flex-direction: column;
    .el-table__empty-text {
      line-height: unset;
      color: #fff;
      display: block;
      margin-top: 5px;
    }
    &::before {
      background: url('../../../assets/images/box.png') no-repeat center;
      background-size: 100% 100%;
      height: 64px;
      width: 64px;
    }
  }
}
</style>
